// extracted by mini-css-extract-plugin
export var badge = "_ve-4";
export var selected = "_ve-1";
export var selectedOverlay = "_ve-5";
export var thumbnailButton = "_ve-0";
export var thumbnailFallback = "_ve-3";
export var thumbnailImage = "_ve-2";